import { render, staticRenderFns } from "./AlarmDetailHistoryTable.vue?vue&type=template&id=331de96e&scoped=true&"
import script from "./AlarmDetailHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AlarmDetailHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331de96e",
  null
  
)

export default component.exports